import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appRadioFocus]'
})
export class RadioFocusDirective {
  @Output() focusChange: EventEmitter<Event> = new EventEmitter<Event>();

  @HostListener('focus')
  onFocus(): void {
    console.log('adhs');
    this.focusChange.emit();
  }

  constructor() { }

}
